export default __webpack_public_path__ + "static/sust-first-39d05c5239c3ab041ccd40e7247e4e04.png";